import {EntityApiService} from '@dofleini/security';

class NomenclaturesTypologiesApiService extends EntityApiService {


}

export default new NomenclaturesTypologiesApiService('/ms-core/api/typologies');
